import React from 'react';
import styles from './ActionButtons.module.scss';
import clsx from 'clsx';
import { useUIGameEndContext } from '../../../../contexts/UIGameEndContext.tsx';
import { T } from '@colonist/ui';
import { UIGameButton } from '../../../../common/UIGameButton/index.ts';
export function MapReplayButton({ text, className }) {
    const { gameEndData, onClickStatsOrReplay } = useUIGameEndContext();
    return /*#__PURE__*/ React.createElement(UIGameButton, {
        className: clsx(styles.button, className),
        onClick: onClickStatsOrReplay,
        variant: "dark"
    }, gameEndData.isReplayAvailable ? /*#__PURE__*/ React.createElement(T, {
        id: {
            key: text
        }
    }) : /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.endGame.cornerButton.map'
        }
    }));
}
